module.exports = __webpack_public_path__ + "assets/valve-valve-well.721c218d.svg";